var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.3691H18.3333V12.5596H10V11.3691ZM10 13.7501H18.3333V14.9406H10V13.7501ZM10 16.131H14.1667V17.3215H10V16.131Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80954 14.9409H2.85716V3.03618H7.12502L9.16074 5.06594L9.50597 5.41713H17.1429V10.179H18.3334V5.41713C18.3334 5.1014 18.2079 4.7986 17.9847 4.57534C17.7614 4.35208 17.4586 4.22666 17.1429 4.22666H10L7.97026 2.19689C7.85951 2.08548 7.72781 1.99709 7.58274 1.93682C7.43767 1.87655 7.28211 1.84558 7.12502 1.8457H2.85716C2.54143 1.8457 2.23863 1.97113 2.01537 2.19439C1.79211 2.41764 1.66669 2.72045 1.66669 3.03618V14.9409C1.66669 15.2567 1.79211 15.5595 2.01537 15.7827C2.23863 16.006 2.54143 16.1314 2.85716 16.1314H8.80954V14.9409Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadDetailsIcon);
export default __webpack_public_path__ + "static/media/lead-details-icon.3b957aa2942197a7e7d22452c6d305c0.svg";
export { ForwardRef as ReactComponent };